import { watch } from 'vue'
import { useConfig } from './useConfig'

/**
 * SEO Hook
 * 动态设置页面SEO元标签（title, description, keywords）
 */
export function useSEO() {
  const { getConfig, loadConfigs } = useConfig()

  // 更新SEO元标签
  const updateSEOTags = () => {
    const siteName = getConfig('site.name', '')
    const siteDescription = getConfig('site.description', '')
    const siteKeywords = getConfig('site.keywords', '')

    // 设置页面标题
    if (siteName) {
      document.title = siteName
    }

    // 设置description meta标签
    let descriptionMeta = document.querySelector('meta[name="description"]')
    if (!descriptionMeta) {
      descriptionMeta = document.createElement('meta')
      descriptionMeta.name = 'description'
      document.head.appendChild(descriptionMeta)
    }
    if (siteDescription) {
      descriptionMeta.content = siteDescription
    }

    // 设置keywords meta标签
    let keywordsMeta = document.querySelector('meta[name="keywords"]')
    if (!keywordsMeta) {
      keywordsMeta = document.createElement('meta')
      keywordsMeta.name = 'keywords'
      document.head.appendChild(keywordsMeta)
    }
    if (siteKeywords) {
      keywordsMeta.content = siteKeywords
    }

    // 设置favicon
    const favicon = getConfig('site.favicon', '')
    if (favicon) {
      let linkIcon = document.querySelector("link[rel*='icon']")
      if (!linkIcon) {
        linkIcon = document.createElement('link')
        linkIcon.rel = 'shortcut icon'
        linkIcon.type = 'image/x-icon'
        document.head.appendChild(linkIcon)
      }
      linkIcon.href = favicon
    }
  }

  // 监听配置加载完成后更新SEO
  watch(() => getConfig('site.name'), () => {
    updateSEOTags()
  })

  // 初始化时加载配置并更新SEO
  loadConfigs().then(() => {
    updateSEOTags()
  })

  return {
    updateSEOTags
  }
}
